export const addBtn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <g filter="url(#filter0_b_2183_8910)">
      <circle cx="20.5547" cy="20" r="20" fill="white" fillOpacity="0.6" />
      <circle
        cx="20.5547"
        cy="20"
        r="19.5"
        stroke="url(#paint0_linear_2183_8910)"
        strokeOpacity="0.3"
      />
    </g>
    <path
      d="M21.86 18.3362H28.8681V20.8365H21.86V28.0911H19.3245V20.8365H12.3164V18.3362H19.3245V11.0464H21.86V18.3362Z"
      fill="black"
    />
    <defs>
      <filter
        id="filter0_b_2183_8910"
        x="-3.44531"
        y="-4"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_2183_8910"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2183_8910"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2183_8910"
        x1="39.5547"
        y1="-2.84836e-06"
        x2="9.05469"
        y2="35.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const addBtnGrey = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g filter="url(#filter0_b_1611_27246)">
      <circle cx="20.0781" cy="20.502" r="20" fill="#EEEEEE" />
      <circle
        cx="20.0781"
        cy="20.502"
        r="19.5"
        stroke="url(#paint0_linear_1611_27246)"
        strokeOpacity="0.3"
      />
    </g>
    <path
      d="M21.3835 18.8381H28.3915V21.3385H21.3835V28.5931H18.8479V21.3385H11.8398V18.8381H18.8479V11.5483H21.3835V18.8381Z"
      fill="black"
    />
    <defs>
      <filter
        id="filter0_b_1611_27246"
        x="-3.92188"
        y="-3.49805"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1611_27246"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1611_27246"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1611_27246"
        x1="39.0781"
        y1="0.50195"
        x2="8.57812"
        y2="36.002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const addBtnGrey2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g filter="url(#filter0_b_1611_27246)">
      <circle cx="20.0781" cy="20.502" r="20" fill="#fff" fillOpacity="0.6" />
      <circle
        cx="20.0781"
        cy="20.502"
        r="19.5"
        stroke="url(#paint0_linear_1611_27246)"
        strokeOpacity="0.3"
      />
    </g>
    <path
      d="M21.3835 18.8381H28.3915V21.3385H21.3835V28.5931H18.8479V21.3385H11.8398V18.8381H18.8479V11.5483H21.3835V18.8381Z"
      fill="black"
    />
    <defs>
      <filter
        id="filter0_b_1611_27246"
        x="-3.92188"
        y="-3.49805"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1611_27246"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1611_27246"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1611_27246"
        x1="39.0781"
        y1="0.50195"
        x2="8.57812"
        y2="36.002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const SleepGraph = (
  <svg
    width="752"
    height="219"
    viewBox="0 0 752 219"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.974365" width="18.4295" height="35.8901" fill="white" />
    <rect
      x="23.5352"
      y="0.974365"
      width="10.7505"
      height="35.8901"
      fill="white"
    />
    <rect
      x="41.9609"
      y="0.974365"
      width="12.2863"
      height="35.8901"
      fill="white"
    />
    <rect
      x="17.3945"
      y="121.694"
      width="7.67896"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="52.7148"
      y="121.694"
      width="6.14317"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="57.3242"
      y="182.599"
      width="7.67896"
      height="35.8901"
      fill="#4D269B"
    />
    <rect
      x="72.6836"
      y="182.599"
      width="19.9653"
      height="35.8901"
      fill="#4D269B"
    />
    <rect
      x="32.7578"
      y="121.694"
      width="10.7505"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="63.4688"
      y="121.694"
      width="10.7505"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="91.1094"
      y="121.694"
      width="148.97"
      height="35.8898"
      fill="#A34DCC"
    />
    <rect
      x="249.293"
      y="121.694"
      width="93.6833"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      width="43.0022"
      height="35.8901"
      transform="matrix(-1 0 0 1 392.176 121.65)"
      fill="#A34DCC"
    />
    <rect
      x="400.141"
      y="121.65"
      width="42.9145"
      height="35.756"
      fill="#A34DCC"
    />
    <rect
      x="453.559"
      y="121.694"
      width="61.4317"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="539.555"
      y="121.694"
      width="18.4295"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="568.738"
      y="121.694"
      width="13.8221"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="633.234"
      y="121.694"
      width="10.7505"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="665.492"
      y="121.694"
      width="9.21475"
      height="35.8901"
      fill="#A34DCC"
    />
    <rect
      x="673.164"
      y="61.8787"
      width="12.2863"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="683.926"
      y="0.974365"
      width="67.5748"
      height="35.8901"
      fill="white"
    />
    <rect
      x="642.453"
      y="0.974365"
      width="24.5727"
      height="35.8901"
      fill="white"
    />
    <rect
      x="613.277"
      y="0.974365"
      width="21.5011"
      height="35.8901"
      fill="white"
    />
    <rect
      x="390.746"
      y="0.974365"
      width="10.7286"
      height="35.756"
      fill="white"
    />
    <rect
      x="581.027"
      y="61.8787"
      width="33.7874"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="513.453"
      y="61.8787"
      width="27.6443"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="556.457"
      y="61.8787"
      width="13.8221"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="441.273"
      y="61.8787"
      width="13.8221"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="341.438"
      y="61.8787"
      width="9.21475"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="238.551"
      y="61.8787"
      width="12.2863"
      height="35.8901"
      fill="#F973FE"
    />
    <rect
      x="17.3945"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint0_linear_1581_24757)"
    />
    <rect
      x="23.5352"
      y="36.8655"
      width="1.53579"
      height="84.8312"
      fill="url(#paint1_linear_1581_24757)"
    />
    <rect
      x="32.7578"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint2_linear_1581_24757)"
    />
    <rect
      x="41.9609"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint3_linear_1581_24757)"
    />
    <rect
      x="52.7148"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint4_linear_1581_24757)"
    />
    <rect
      x="57.3242"
      y="157.585"
      width="1.53579"
      height="25.0143"
      fill="url(#paint5_linear_1581_24757)"
    />
    <rect
      x="63.4688"
      y="157.585"
      width="1.53579"
      height="25.0143"
      fill="url(#paint6_linear_1581_24757)"
    />
    <rect
      x="72.6836"
      y="157.585"
      width="1.53579"
      height="25.0143"
      fill="url(#paint7_linear_1581_24757)"
    />
    <rect
      x="91.1094"
      y="157.585"
      width="1.53579"
      height="25.0143"
      fill="url(#paint8_linear_1581_24757)"
    />
    <rect
      x="238.551"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint9_linear_1581_24757)"
    />
    <rect
      x="249.293"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint10_linear_1581_24757)"
    />
    <rect
      x="341.438"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint11_linear_1581_24757)"
    />
    <rect
      x="349.113"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint12_linear_1581_24757)"
    />
    <rect
      x="390.746"
      y="36.7295"
      width="1.34108"
      height="84.9205"
      fill="url(#paint13_linear_1581_24757)"
    />
    <rect
      x="400.141"
      y="36.7295"
      width="1.34108"
      height="84.9205"
      fill="url(#paint14_linear_1581_24757)"
    />
    <rect
      x="441.273"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint15_linear_1581_24757)"
    />
    <rect
      x="453.559"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint16_linear_1581_24757)"
    />
    <rect
      x="513.453"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint17_linear_1581_24757)"
    />
    <rect
      x="539.555"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint18_linear_1581_24757)"
    />
    <rect
      x="556.457"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint19_linear_1581_24757)"
    />
    <rect
      x="568.738"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint20_linear_1581_24757)"
    />
    <rect
      x="581.027"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint21_linear_1581_24757)"
    />
    <rect
      x="613.277"
      y="36.8655"
      width="1.53579"
      height="25.0143"
      fill="url(#paint22_linear_1581_24757)"
    />
    <rect
      x="683.926"
      y="36.8657"
      width="1.53579"
      height="25.0143"
      fill="url(#paint23_linear_1581_24757)"
    />
    <rect
      x="633.234"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint24_linear_1581_24757)"
    />
    <rect
      x="642.453"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint25_linear_1581_24757)"
    />
    <rect
      x="665.492"
      y="36.8657"
      width="1.53579"
      height="84.8312"
      fill="url(#paint26_linear_1581_24757)"
    />
    <rect
      x="673.164"
      y="97.7676"
      width="1.53579"
      height="23.9267"
      fill="url(#paint27_linear_1581_24757)"
    />

    <defs>
      <linearGradient
        id="paint0_linear_1581_24757"
        x1="18.1624"
        y1="36.8657"
        x2="18.1624"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1581_24757"
        x1="24.3031"
        y1="36.8655"
        x2="24.3031"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1581_24757"
        x1="33.5257"
        y1="36.8657"
        x2="33.5257"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1581_24757"
        x1="42.7288"
        y1="36.8657"
        x2="42.7288"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1581_24757"
        x1="53.4827"
        y1="36.8657"
        x2="53.4827"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1581_24757"
        x1="58.0921"
        y1="157.585"
        x2="58.0921"
        y2="182.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1581_24757"
        x1="64.2366"
        y1="157.585"
        x2="64.2366"
        y2="182.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1581_24757"
        x1="73.4515"
        y1="157.585"
        x2="73.4515"
        y2="182.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1581_24757"
        x1="91.8773"
        y1="157.585"
        x2="91.8773"
        y2="182.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1581_24757"
        x1="239.319"
        y1="97.7676"
        x2="239.319"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1581_24757"
        x1="250.061"
        y1="97.7676"
        x2="250.061"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1581_24757"
        x1="342.205"
        y1="97.7676"
        x2="342.205"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1581_24757"
        x1="349.881"
        y1="97.7676"
        x2="349.881"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1581_24757"
        x1="391.417"
        y1="36.7295"
        x2="391.417"
        y2="121.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1581_24757"
        x1="400.811"
        y1="36.7295"
        x2="400.811"
        y2="121.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1581_24757"
        x1="442.041"
        y1="97.7676"
        x2="442.041"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1581_24757"
        x1="454.326"
        y1="97.7676"
        x2="454.326"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1581_24757"
        x1="514.221"
        y1="97.7676"
        x2="514.221"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1581_24757"
        x1="540.323"
        y1="97.7676"
        x2="540.323"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1581_24757"
        x1="557.225"
        y1="97.7676"
        x2="557.225"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1581_24757"
        x1="569.506"
        y1="97.7676"
        x2="569.506"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1581_24757"
        x1="581.795"
        y1="97.7676"
        x2="581.795"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1581_24757"
        x1="614.045"
        y1="36.8655"
        x2="614.045"
        y2="61.8798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F973FE" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1581_24757"
        x1="684.694"
        y1="36.8657"
        x2="684.694"
        y2="61.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F973FE" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1581_24757"
        x1="634.002"
        y1="36.8657"
        x2="634.002"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_1581_24757"
        x1="643.221"
        y1="36.8657"
        x2="643.221"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1581_24757"
        x1="666.26"
        y1="36.8657"
        x2="666.26"
        y2="121.697"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1581_24757"
        x1="673.932"
        y1="97.7676"
        x2="673.932"
        y2="121.694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
    </defs>
  </svg>
);

export const SleepGraphResp = (
  <svg
    width="279"
    height="182"
    viewBox="0 0 279 182"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-0.25"
      y="0.818848"
      width="6.84664"
      height="29.7378"
      fill="white"
    />
    <rect
      x="8.30859"
      y="0.818848"
      width="3.99388"
      height="29.7378"
      fill="white"
    />
    <rect
      x="15.1523"
      y="0.818848"
      width="4.56443"
      height="29.7378"
      fill="white"
    />
    <rect
      x="6.02734"
      y="100.845"
      width="2.85277"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="19.1484"
      y="100.845"
      width="2.28221"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="20.8594"
      y="151.309"
      width="2.85277"
      height="29.7378"
      fill="#4D269B"
    />
    <rect
      x="26.5664"
      y="151.309"
      width="7.4172"
      height="29.7378"
      fill="#4D269B"
    />
    <rect
      x="11.7344"
      y="100.845"
      width="3.99388"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="23.1445"
      y="100.845"
      width="3.99388"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="33.4102"
      y="100.844"
      width="55.3432"
      height="29.7375"
      fill="#A34DCC"
    />
    <rect
      x="92.1797"
      y="100.845"
      width="34.8038"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      width="15.9755"
      height="29.7378"
      transform="matrix(-1 0 0 1 145.258 100.808)"
      fill="#A34DCC"
    />
    <rect
      x="148.219"
      y="100.808"
      width="15.9429"
      height="29.6267"
      fill="#A34DCC"
    />
    <rect
      x="168.062"
      y="100.844"
      width="22.8222"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="200.012"
      y="100.845"
      width="6.84664"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="210.852"
      y="100.845"
      width="5.13498"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="234.812"
      y="100.845"
      width="3.99388"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="246.797"
      y="100.845"
      width="3.42332"
      height="29.7378"
      fill="#A34DCC"
    />
    <rect
      x="249.648"
      y="51.2827"
      width="4.56443"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="253.645"
      y="0.818848"
      width="25.1044"
      height="29.7378"
      fill="white"
    />
    <rect
      x="238.238"
      y="0.818848"
      width="9.12886"
      height="29.7378"
      fill="white"
    />
    <rect
      x="227.398"
      y="0.818848"
      width="7.98775"
      height="29.7378"
      fill="white"
    />
    <rect
      x="144.727"
      y="0.818848"
      width="3.98573"
      height="29.6267"
      fill="white"
    />
    <rect
      x="215.418"
      y="51.2827"
      width="12.5522"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="190.316"
      y="51.2827"
      width="10.27"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="206.289"
      y="51.2827"
      width="5.13498"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="163.5"
      y="51.2827"
      width="5.13498"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="126.41"
      y="51.2827"
      width="3.42332"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="88.1875"
      y="51.2827"
      width="4.56443"
      height="29.7378"
      fill="#F973FE"
    />
    <rect
      x="6.02734"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint0_linear_1581_25439)"
    />
    <rect
      x="8.30859"
      y="30.5566"
      width="0.570554"
      height="70.2893"
      fill="url(#paint1_linear_1581_25439)"
    />
    <rect
      x="11.7344"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint2_linear_1581_25439)"
    />
    <rect
      x="15.1523"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint3_linear_1581_25439)"
    />
    <rect
      x="19.1484"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint4_linear_1581_25439)"
    />
    <rect
      x="20.8594"
      y="130.583"
      width="0.570554"
      height="20.7263"
      fill="url(#paint5_linear_1581_25439)"
    />
    <rect
      x="23.1445"
      y="130.583"
      width="0.570554"
      height="20.7263"
      fill="url(#paint6_linear_1581_25439)"
    />
    <rect
      x="26.5664"
      y="130.583"
      width="0.570554"
      height="20.7263"
      fill="url(#paint7_linear_1581_25439)"
    />
    <rect
      x="33.4102"
      y="130.583"
      width="0.570554"
      height="20.7263"
      fill="url(#paint8_linear_1581_25439)"
    />
    <rect
      x="88.1875"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint9_linear_1581_25439)"
    />
    <rect
      x="92.1797"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint10_linear_1581_25439)"
    />
    <rect
      x="126.41"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint11_linear_1581_25439)"
    />
    <rect
      x="129.262"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint12_linear_1581_25439)"
    />
    <rect
      x="144.727"
      y="30.4448"
      width="0.498216"
      height="70.3633"
      fill="url(#paint13_linear_1581_25439)"
    />
    <rect
      x="148.219"
      y="30.4448"
      width="0.498216"
      height="70.3633"
      fill="url(#paint14_linear_1581_25439)"
    />
    <rect
      x="163.5"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint15_linear_1581_25439)"
    />
    <rect
      x="168.062"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint16_linear_1581_25439)"
    />
    <rect
      x="190.316"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint17_linear_1581_25439)"
    />
    <rect
      x="200.012"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint18_linear_1581_25439)"
    />
    <rect
      x="206.289"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint19_linear_1581_25439)"
    />
    <rect
      x="210.852"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint20_linear_1581_25439)"
    />
    <rect
      x="215.418"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint21_linear_1581_25439)"
    />
    <rect
      x="227.398"
      y="30.5566"
      width="0.570554"
      height="20.7263"
      fill="url(#paint22_linear_1581_25439)"
    />
    <rect
      x="253.645"
      y="30.5581"
      width="0.570554"
      height="20.7263"
      fill="url(#paint23_linear_1581_25439)"
    />
    <rect
      x="234.812"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint24_linear_1581_25439)"
    />
    <rect
      x="238.238"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint25_linear_1581_25439)"
    />
    <rect
      x="246.797"
      y="30.5581"
      width="0.570554"
      height="70.2893"
      fill="url(#paint26_linear_1581_25439)"
    />
    <rect
      x="249.648"
      y="81.0195"
      width="0.570554"
      height="19.8252"
      fill="url(#paint27_linear_1581_25439)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1581_25439"
        x1="6.31262"
        y1="30.5581"
        x2="6.31262"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1581_25439"
        x1="8.59387"
        y1="30.5566"
        x2="8.59387"
        y2="100.846"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1581_25439"
        x1="12.0197"
        y1="30.5581"
        x2="12.0197"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1581_25439"
        x1="15.4376"
        y1="30.5581"
        x2="15.4376"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1581_25439"
        x1="19.4337"
        y1="30.5581"
        x2="19.4337"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1581_25439"
        x1="21.1447"
        y1="130.583"
        x2="21.1447"
        y2="151.309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1581_25439"
        x1="23.4298"
        y1="130.583"
        x2="23.4298"
        y2="151.309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1581_25439"
        x1="26.8517"
        y1="130.583"
        x2="26.8517"
        y2="151.309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1581_25439"
        x1="33.6954"
        y1="130.583"
        x2="33.6954"
        y2="151.309"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1581_25439"
        x1="88.4728"
        y1="81.0195"
        x2="88.4728"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1581_25439"
        x1="92.465"
        y1="81.0195"
        x2="92.465"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1581_25439"
        x1="126.695"
        y1="81.0195"
        x2="126.695"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1581_25439"
        x1="129.547"
        y1="81.0195"
        x2="129.547"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1581_25439"
        x1="144.976"
        y1="30.4448"
        x2="144.976"
        y2="100.808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1581_25439"
        x1="148.468"
        y1="30.4448"
        x2="148.468"
        y2="100.808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1581_25439"
        x1="163.785"
        y1="81.0195"
        x2="163.785"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1581_25439"
        x1="168.348"
        y1="81.0195"
        x2="168.348"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1581_25439"
        x1="190.602"
        y1="81.0195"
        x2="190.602"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1581_25439"
        x1="200.297"
        y1="81.0195"
        x2="200.297"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1581_25439"
        x1="206.574"
        y1="81.0195"
        x2="206.574"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1581_25439"
        x1="211.137"
        y1="81.0195"
        x2="211.137"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1581_25439"
        x1="215.703"
        y1="81.0195"
        x2="215.703"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1581_25439"
        x1="227.684"
        y1="30.5566"
        x2="227.684"
        y2="51.283"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F973FE" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1581_25439"
        x1="253.93"
        y1="30.5581"
        x2="253.93"
        y2="51.2844"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F973FE" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1581_25439"
        x1="235.098"
        y1="30.5581"
        x2="235.098"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_1581_25439"
        x1="238.524"
        y1="30.5581"
        x2="238.524"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1581_25439"
        x1="247.082"
        y1="30.5581"
        x2="247.082"
        y2="100.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1581_25439"
        x1="249.934"
        y1="81.0195"
        x2="249.934"
        y2="100.845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
    </defs>
  </svg>
);
